module.exports = __webpack_public_path__ + "img/pers-mot-des-architectes.fc9745c6.jpg";